export const languageStorageKey = 'PORTAL_LOC_CONTEXT';
export const languageDateStorageKey = 'PORTAL_LOC_CONTEXT_DATE';
export const defaultLanguage = 'en';
// The addition of any new languages should be followed with an import of the locale in the `portal-date` file.
export const Languages = {
    'en': 'English',
    'ja': '日本語',
    'de': 'Deutsch',
    'es': 'Español',
    'es-mx': 'Español (México)',
    'fr': 'Français',
    'ko': '한국어',
    'pt': 'Português',
    'pt-br': 'Português (Brasil)',
    'ru': 'Pусский',
    'tr': 'Türkçe',
    'zh-cn': '中文(简体)',
    'keys': 'Localization Keys',
};
